// Visual distinction between direct property-owner listings and
// intermediary/agent listings, used across tables, cards, and detail views.
const isIntermediary = (ownerType = "") => ownerType.toLowerCase().includes("vasit");

export const OwnerBadge = ({ ownerType, size = "sm", className = "" }) => {
  if (!ownerType) return null;
  const intermediary = isIntermediary(ownerType);
  const sizeCls = size === "xs" ? "text-[9px] px-1.5 py-0.5" : "text-xs px-2 py-0.5";
  return (
    <span
      className={`inline-flex items-center rounded-md font-semibold shadow-sm whitespace-nowrap ${sizeCls} ${
        intermediary ? "bg-yellow-400 text-yellow-950" : "bg-emerald-500 text-white"
      } ${className}`}
    >
      {ownerType}
    </span>
  );
};
